<template>
  <v-card
    elevation="0"
    class="card-box-shadow pa-0 w-100 h-100 rounded-lg"
    style="overflow-y: auto"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption font-weight-bold">
        <Span> {{ tripModule.trip }} Details </Span>
      </h5>

      <div
        v-if="dataObj && dataObj.reference_number"
        @click="$emit('redirectTrip', dataObj)"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <h6 class="text-caption font-weight-bold" v-bind="attrs" v-on="on">
              <span style="color: #2196f3"
                >(
                {{ dataObj.reference_number }}
                )</span
              >
            </h6>
          </template>
          <span>{{ tripModule.trip }} Reference Number</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle
      v-if="
        dataObj &&
        (dataObj.driver_name ||
          dataObj.driver_contact_number ||
          dataObj.vehicle_number)
      "
    >
      <v-row no-gutters>
        <v-col cols="6" class="mb-4">
          <router-link
            title="View Driver Details"
            class="d-flex"
            style="text-decoration: none"
            :to="{
              name: 'driver-detail',
              params: {
                id: dataObj.driver_id,
              },
            }"
          >
            <BoxIconWithText
              icon="mdi-account"
              :title="fleetModule.driver"
              :text="dataObj.driver_name"
            />
          </router-link>
        </v-col>
        <v-col cols="6" class="d-flex mb-4">
          <BoxIconWithText
            icon="mdi-phone"
            title="Contact No"
            :text="dataObj.driver_contact_number"
          />
        </v-col>
        <v-col cols="6" class="mb-4" v-if="dataObj.vehicle_number">
          <router-link
            class="d-flex"
            title="View Vehicle Details"
            style="text-decoration: none"
            :to="{
              name: 'vehicle-detail',
              params: {
                id: dataObj.vehicle_id,
              },
            }"
          >
            <BoxIconWithText
              icon="mdi-truck"
              :title="fleetModule.vehicle"
              :text="dataObj.vehicle_number"
            />
          </router-link>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-subtitle v-else class="d-flex align-center justify-center">
      <h5 class="font-weight-bold text_color--text text-center py-9">
        No {{ tripModule.trip }} has been created
      </h5>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import {
  configurationModule,
  customerModule,
  orderModule,
  tripModule,
  fleetModule,
  itemModule,
} from "@/utils/moduleMapping";
import BoxIconWithText from "@/components/BaseComponents/BoxIconWithText.vue";
export default {
  components: { BoxIconWithText },
  props: {
    dataObj: {
      required: true,
    },
  },
  data() {
    return {
      fleetModule,
      tripModule,
      itemModule,
    };
  },
};
</script>